import { Artifact } from "@/types/types";
import { GroupOrUnknownDisplayName } from "../GroupDisplayName";
import { UserOrUnknownDisplayName } from "../UserDisplayName";
import { DatesDisplay } from "./DatesDisplay";

type ArtifactMetadataProps = {
  artifact: Artifact;
};

export const ArtifactMetadata = ({ artifact }: ArtifactMetadataProps) => {
  return (
    <>
      <DatesDisplay
        dateCreated={artifact.dateCreated}
        dateUpdated={artifact.dateUpdated}
      />
      <UserOrUnknownDisplayName user={artifact.user} />
      <GroupOrUnknownDisplayName group={artifact.group} />
    </>
  );
};
